import get from 'lodash.get';
import { selectHarvestEvents } from 'services/harvestEvents/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

const selectEntityId = createDeepEqualSelector(
    makeSelectQueryStringValue('selectedEvent'),
    selectHarvestEvents,
    (harvestEventUuid: string, harvestEvents) =>
        get(harvestEvents, [harvestEventUuid, 'entityId'])
);

export { selectEntityId };
